import { render } from "./IconNotification1.vue?vue&type=template&id=16443ff8"
import script from "./IconNotification1.vue?vue&type=script&lang=js"
export * from "./IconNotification1.vue?vue&type=script&lang=js"
script.render = render

export default script